// test744
(744 && 0);
